function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import defaultMoment from 'moment';
var defaultFormats = {
  normalDateWithWeekday: "ddd, MMM D",
  normalDate: "D MMMM",
  shortDate: "MMM D",
  monthAndDate: "MMMM D",
  dayOfMonth: "D",
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  monthAndYear: "MMMM YYYY",
  weekday: "dddd",
  weekdayShort: "ddd",
  minutes: "mm",
  hours12h: "hh",
  hours24h: "HH",
  seconds: "ss",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  fullDate: "ll",
  fullDateWithWeekday: "dddd, LL",
  fullDateTime: "lll",
  fullDateTime12h: "ll hh:mm A",
  fullDateTime24h: "ll HH:mm",
  keyboardDate: "L",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
};
var MomentUtils = /*#__PURE__*/_createClass(function MomentUtils() {
  var _this = this;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    locale = _ref.locale,
    formats = _ref.formats,
    instance = _ref.instance;
  _classCallCheck(this, MomentUtils);
  this.lib = "moment";
  this.is12HourCycleInCurrentLocale = function () {
    return /A|a/.test(_this.moment.localeData(_this.getCurrentLocaleCode()).longDateFormat("LT"));
  };
  this.getFormatHelperText = function (format) {
    var _a, _b;
    // @see https://github.com/moment/moment/blob/develop/src/lib/format/format.js#L6
    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})|./g;
    return (_b = (_a = format.match(localFormattingTokens)) === null || _a === void 0 ? void 0 : _a.map(function (token) {
      var firstCharacter = token[0];
      if (firstCharacter === "L" || firstCharacter === ";") {
        return _this.moment.localeData(_this.getCurrentLocaleCode()).longDateFormat(token);
      }
      return token;
    }).join("").replace(/a/gi, "(a|p)m").toLocaleLowerCase()) !== null && _b !== void 0 ? _b : format;
  };
  this.getCurrentLocaleCode = function () {
    return _this.locale || _this.moment.locale();
  };
  this.parseISO = function (isoString) {
    return _this.moment(isoString, true);
  };
  this.toISO = function (value) {
    return value.toISOString();
  };
  this.parse = function (value, format) {
    if (value === "") {
      return null;
    }
    if (_this.locale) {
      return _this.moment(value, format, _this.locale, true);
    }
    return _this.moment(value, format, true);
  };
  this.date = function (value) {
    if (value === null) {
      return null;
    }
    var moment = _this.moment(value);
    if (_this.locale) {
      moment.locale(_this.locale);
    }
    return moment;
  };
  this.toJsDate = function (value) {
    return value.toDate();
  };
  this.isValid = function (value) {
    return _this.moment(value).isValid();
  };
  this.isNull = function (date) {
    return date === null;
  };
  this.getDiff = function (date, comparing, unit) {
    if (!_this.moment(comparing).isValid()) {
      return 0;
    }
    return date.diff(comparing, unit);
  };
  this.isAfter = function (date, value) {
    return date.isAfter(value);
  };
  this.isBefore = function (date, value) {
    return date.isBefore(value);
  };
  this.isAfterDay = function (date, value) {
    return date.isAfter(value, "day");
  };
  this.isBeforeDay = function (date, value) {
    return date.isBefore(value, "day");
  };
  this.isBeforeMonth = function (date, value) {
    return date.isBefore(value, "month");
  };
  this.isAfterMonth = function (date, value) {
    return date.isAfter(value, "month");
  };
  this.isBeforeYear = function (date, value) {
    return date.isBefore(value, "year");
  };
  this.isAfterYear = function (date, value) {
    return date.isAfter(value, "year");
  };
  this.startOfDay = function (date) {
    return date.clone().startOf("day");
  };
  this.endOfDay = function (date) {
    return date.clone().endOf("day");
  };
  this.format = function (date, formatKey) {
    return _this.formatByString(date, _this.formats[formatKey]);
  };
  this.formatByString = function (date, formatString) {
    var clonedDate = date.clone();
    if (_this.locale) {
      clonedDate.locale(_this.locale);
    }
    return clonedDate.format(formatString);
  };
  this.formatNumber = function (numberToFormat) {
    return numberToFormat;
  };
  this.getHours = function (date) {
    return date.get("hours");
  };
  this.addSeconds = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "seconds") : date.clone().add(count, "seconds");
  };
  this.addMinutes = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "minutes") : date.clone().add(count, "minutes");
  };
  this.addHours = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "hours") : date.clone().add(count, "hours");
  };
  this.addDays = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "days") : date.clone().add(count, "days");
  };
  this.addWeeks = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "weeks") : date.clone().add(count, "weeks");
  };
  this.addMonths = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "months") : date.clone().add(count, "months");
  };
  this.addYears = function (date, count) {
    return count < 0 ? date.clone().subtract(Math.abs(count), "years") : date.clone().add(count, "years");
  };
  this.setHours = function (date, count) {
    return date.clone().hours(count);
  };
  this.getMinutes = function (date) {
    return date.get("minutes");
  };
  this.setMinutes = function (date, count) {
    return date.clone().minutes(count);
  };
  this.getSeconds = function (date) {
    return date.get("seconds");
  };
  this.setSeconds = function (date, count) {
    return date.clone().seconds(count);
  };
  this.getMonth = function (date) {
    return date.get("month");
  };
  this.getDaysInMonth = function (date) {
    return date.daysInMonth();
  };
  this.isSameDay = function (date, comparing) {
    return date.isSame(comparing, "day");
  };
  this.isSameMonth = function (date, comparing) {
    return date.isSame(comparing, "month");
  };
  this.isSameYear = function (date, comparing) {
    return date.isSame(comparing, "year");
  };
  this.isSameHour = function (date, comparing) {
    return date.isSame(comparing, "hour");
  };
  this.setMonth = function (date, count) {
    return date.clone().month(count);
  };
  this.getMeridiemText = function (ampm) {
    if (_this.is12HourCycleInCurrentLocale()) {
      // AM/PM translation only possible in those who have 12 hour cycle in locale.
      return _this.moment.localeData(_this.getCurrentLocaleCode()).meridiem(ampm === "am" ? 0 : 13, 0, false);
    }
    return ampm === "am" ? "AM" : "PM"; // fallback for de, ru, ...etc
  };

  this.startOfYear = function (date) {
    return date.clone().startOf("year");
  };
  this.endOfYear = function (date) {
    return date.clone().endOf("year");
  };
  this.startOfMonth = function (date) {
    return date.clone().startOf("month");
  };
  this.endOfMonth = function (date) {
    return date.clone().endOf("month");
  };
  this.startOfWeek = function (date) {
    return date.clone().startOf("week");
  };
  this.endOfWeek = function (date) {
    return date.clone().endOf("week");
  };
  this.getNextMonth = function (date) {
    return date.clone().add(1, "month");
  };
  this.getPreviousMonth = function (date) {
    return date.clone().subtract(1, "month");
  };
  this.getMonthArray = function (date) {
    var firstMonth = date.clone().startOf("year");
    var monthArray = [firstMonth];
    while (monthArray.length < 12) {
      var prevMonth = monthArray[monthArray.length - 1];
      monthArray.push(_this.getNextMonth(prevMonth));
    }
    return monthArray;
  };
  this.getYear = function (date) {
    return date.get("year");
  };
  this.setYear = function (date, year) {
    return date.clone().set("year", year);
  };
  this.getDate = function (date) {
    return date.get("date");
  };
  this.setDate = function (date, year) {
    return date.clone().set("date", year);
  };
  this.mergeDateAndTime = function (date, time) {
    return date.hour(time.hour()).minute(time.minute()).second(time.second());
  };
  this.getWeekdays = function () {
    return _this.moment.weekdaysShort(true);
  };
  this.isEqual = function (value, comparing) {
    if (value === null && comparing === null) {
      return true;
    }
    return _this.moment(value).isSame(comparing);
  };
  this.getWeekArray = function (date) {
    var start = date.clone().startOf("month").startOf("week");
    var end = date.clone().endOf("month").endOf("week");
    var count = 0;
    var current = start;
    var nestedWeeks = [];
    while (current.isBefore(end)) {
      var weekNumber = Math.floor(count / 7);
      nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
      nestedWeeks[weekNumber].push(current);
      current = current.clone().add(1, "day");
      count += 1;
    }
    return nestedWeeks;
  };
  this.getYearRange = function (start, end) {
    var startDate = _this.moment(start).startOf("year");
    var endDate = _this.moment(end).endOf("year");
    var years = [];
    var current = startDate;
    while (current.isBefore(endDate)) {
      years.push(current);
      current = current.clone().add(1, "year");
    }
    return years;
  };
  this.isWithinRange = function (date, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      start = _ref3[0],
      end = _ref3[1];
    return date.isBetween(start, end, null, "[]");
  };
  this.moment = instance || defaultMoment;
  this.locale = locale;
  this.formats = Object.assign({}, defaultFormats, formats);
});
export { MomentUtils as default };